<td
    class="member-cell d-flex"
    [ngbTooltip]="flmi2Person.isSubordinate == true ? mi2Team_tooltip : ''"
    tooltipClass="oa-widget-tooltip"
    [class.nonreporting]="flmi2Person.leftEarly == true"
>
    <div class="member-name-icon-container">
        <div
            class="member-name-container row text-left d-flex justify-content-start align-items-center"
            (click)="getFlMi2PersonDR()"
            [ngClass]="{ indent: flmi2Person.isSubordinate == true }"
        >
            <cmps-icon
                class="cmps-cdk-fill-grey-300 cmps-cdk-text-center member-chevron"
                svgIcon="chevron-down"
                *ngIf="
                    flmi2Person.bottomRole !== true &&
                    flmi2Person.subOrdinates != null
                "
            ></cmps-icon>
            <cmps-icon
                class="cmps-cdk-fill-grey-300 cmps-cdk-text-center member-chevron"
                svgIcon="chevron-right"
                *ngIf="
                    flmi2Person.bottomRole !== true &&
                    flmi2Person.subOrdinates == null
                "
            ></cmps-icon>
            <div
                class="cmps-cdk-pl-2"
                *ngIf="flmi2Person.bottomRole === true"
            ></div>
            <span class="member-name">
                <span class="photo-name-sec">
                    <cmps-icon
                        class="user-icon"
                        svgIcon="account-circle"
                    ></cmps-icon>
                    <span
                        class="user-name-text"
                        [class.underline]="flmi2Person.bottomRole == true"
                        placement="right"
                        container="body"
                    >
                        {{ flmi2Person.firstName | titlecase }}
                        {{ flmi2Person.lastName | titlecase }}
                        <small *ngIf="flmi2Person.isSubordinate">
                            ({{ flmi2Person.role }})</small
                        >
                    </span>
                </span>
            </span>
            <span
                *ngIf="loadingFlMi2Team"
                class="expand-icon d-block ml-2"
            >
                <cmps-wait-status></cmps-wait-status>
            </span>
        </div>
    </div>
</td>

<td [style.color]="flmi2Person.thresholdColor">
    <span
        class="floa-score"
        placement="top"
        container="body"
    >
        {{
            flmi2Person.mi2Score != null
                ? (flmi2Person.mi2Score | number: '1.2-2')
                : '-'
        }}
    </span>
    <span
        class="score-percentage"
        *ngIf="flmi2Person.mi2Score != null"
        >%</span
    >
</td>

<td>
    {{ flmi2Person.totalDirectReports | number: '1.0-0' }}
</td>

<td class="p-1">
    <div
        class="custom-row-bar"
        [ngbTooltip]="mi2_date_tooltip"
        tooltipClass="oa-widget-tooltip"
        [placement]="['top', 'bottom']"
    >
        <div class="fraction-table-container funded-batch">
            <!-- ###################  ADD frontline mi2 grid MI2 Data Bar  ################### -->
            <fraction-bar-mi2
                class="fraction-bar"
                *ngIf="flmi2Person.mi2Score != null"
                [numerator]="flmi2Person.totalImproving"
                [denominator]="flmi2Person.totalDeclining"
                [divisor]="
                    flmi2Person.maxExpectedOpportunities != null
                        ? flmi2Person.maxExpectedOpportunities
                        : flmi2Person.totalDirectReports
                "
                [maxNumerator]="flmi2Person.maxCoached"
                [maxDenominator]="flmi2Person.maxUncoached"
                [numeratorClass]="'green'"
                [denominatorClass]="'red'"
                [numeratorLabel]="flmi2Person.totalImproving"
                [denominatorLabel]="flmi2Person.totalDeclining"
                [showHoverTooltip]="flmi2Person.isSubordinate"
                [hoverTemplate]="mi2_date_tooltip"
                [hoverData]="{
                    uncoached: flmi2Person.percentUncoached,
                    coached: flmi2Person.percentCoached
                }"
            >
            </fraction-bar-mi2>
        </div>
        <div class="p-1 score score-bg-color">
            {{ flmi2Person.totalNoScore }}
        </div>
    </div>
</td>
<!-- ###################  ADD frontline mi2 grid MI2 Data Popup  ################### -->
<ng-template #mi2_date_tooltip>
    <div class="cmps-mi2-main--categories cmps-mi2-main--categories-box">
        <h6>{{ i18n._11158_MI2_DETAIL | translate }}</h6>
        <div
            class="cmps-mi2-main--category"
            *ngFor="let cat of flmi2Person?.flMi2Details"
        >
            <div class="cmps-mi2-main--category--info">
                <div class="cmps-mi2-main--category--info-num">
                    <button class="cmps-mi2-main--category--info-name-button">
                        {{ cat.scorecardImprovementCategoryName }}
                    </button>
                    <div class="cmps-mi2-main--category--info-num-performers">
                        <div
                            class="cmps-mi2-main--category--info-num-performers-count"
                        >
                            {{ cat?.totalScorecardImprovementCategory }}
                        </div>
                        <cmps-icon svgIcon="account"></cmps-icon>
                    </div>
                </div>
                <div class="cmps-mi2-main--category--info-groups">
                    <div
                        class="cmps-mi2-main--category--group"
                        *ngFor="let grp of cat?.mi2ImproveGroupCategories"
                    >
                        <div class="cmps-mi2-main--category--group-item-num">
                            <button
                                class="cmps-mi2-main--category--info-num-button"
                                [style.background-color]="grp?.colour"
                            >
                                <span>{{ grp?.totalScoreCategoryId }}</span>
                                <cmps-icon svgIcon="account"></cmps-icon>
                            </button>
                        </div>
                        <div
                            class="cmps-mi2-main--category--group-item-percent"
                        >
                            {{ grp?.perTotalScoreCategory }} %
                        </div>
                        <div class="cmps-mi2-main--category--group-item-text">
                            {{ grp?.scorecardImprovementGroupName }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<!-- ###################  ADD frontline mi2 grid Team Popup  ################### -->
<ng-template #mi2Team_tooltip>
    <div class="custom-tooltip custom-user-tooltip no-min-width oatooltip">
        <p>
            <strong
                ><b
                    >{{ i18n._11144_SUPERGROUP_NAME___ | translate }}:</b
                ></strong
            >
            {{ flmi2Person.superGroup | translate }}
        </p>
        <p>
            <strong
                ><b
                    >{{ i18n._11145_DAYS_IN_SUPERGROUP___ | translate }}:</b
                ></strong
            >
            {{ flmi2Person.daysInSuperGroup | translate }}
        </p>
        <p>
            <strong
                ><b>{{ i18n._48_MANAGER___ | translate }}:</b></strong
            >
            {{ flmi2Person.managerFirstName | translate }}
            {{ flmi2Person.managerLastName | translate }}
        </p>
        <p>
            <strong
                ><b>{{ i18n._59_ROLE___ | translate }}:</b></strong
            >
            {{ flmi2Person.role | translate }}
        </p>
    </div>
</ng-template>
